import { Edit } from "@carbon/react/icons";
import NextLink from "next/link";
import { claimEditsHref, wikiEditedCopy } from "@/lib/ui/wiki";

export function ClaimEditedLink({
  claimId,
  compact = false,
  href,
}: {
  claimId: string;
  compact?: boolean;
  href?: string;
}) {
  const target = href ?? claimEditsHref(claimId);
  if (compact) {
    return (
      <NextLink
        href={target}
        className="claim-edited-icon"
        aria-label={wikiEditedCopy.hint}
        title={wikiEditedCopy.hint}
      >
        <Edit size={16} />
      </NextLink>
    );
  }

  return (
    <NextLink
      href={target}
      className="chat-composer-icon chat-composer-icon--edited"
      aria-label={wikiEditedCopy.hint}
    >
      <Edit size={16} />
      <span className="chat-composer-mode-label">{wikiEditedCopy.badge}</span>
      <span className="chat-composer-tip">{wikiEditedCopy.hint}</span>
    </NextLink>
  );
}
